import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { useGetAllRollUpTheRimsQuery } from 'generated/sanity-graphql';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { useLocalizedUrls } from '../hooks/use-localized-urls';
import { useRollsRemaining } from '../hooks/use-rolls-remaining';

import { HomepageBannerView } from './homepage-banner.view';

const HomepageBanner: React.FC = () => {
  const { isAuthenticated } = useAuthContext();
  const isUserAuthenticated = isAuthenticated();
  const { rollUpTheRimLandingPageUrl, rollUpTheRimRulesUrl } = useLocalizedUrls();
  const { data: sanityData, loading: rutrLoading } = useGetAllRollUpTheRimsQuery();
  const { rollsRemaining, loading: rollsRemainingLoading } = useRollsRemaining({
    isAuthenticated: isUserAuthenticated,
  });
  const { formatMessage } = useIntl();
  const enableRutr = useFlag(LaunchDarklyFlag.ENABLE_RUTR);
  const enableRutrHomePageBanner = useFlag(LaunchDarklyFlag.ENABLE_RUTR_HOME_PAGE_BANNER);

  const enterButtonUrl = useMemo(() => {
    if (enableRutr) {
      return isUserAuthenticated
        ? rollUpTheRimLandingPageUrl
        : formatMessage({ id: 'routes.signIn' });
    }
    // If campaign is not running,
    // redirect to the RUTW rules
    return rollUpTheRimRulesUrl;
  }, [
    enableRutr,
    formatMessage,
    isUserAuthenticated,
    rollUpTheRimLandingPageUrl,
    rollUpTheRimRulesUrl,
  ]);

  if (!enableRutrHomePageBanner || rutrLoading || !sanityData) {
    return null;
  }

  const rollUpTheRim = sanityData?.allRollUpTheRims?.[0];
  const enterButtonLabel = rollUpTheRim?.enterButtonText?.localeRaw?.[0]?.children?.[0]?.text || '';
  const header = rollUpTheRim?.homepageHeader?.localeRaw || [];
  const cupImage = rollUpTheRim?.homepageCupImage?.locale?.app || null;
  const rulesText = rollUpTheRim?.rulesText?.localeRaw || [];

  return (
    <HomepageBannerView
      cupImage={cupImage}
      enterButtonLabel={enterButtonLabel}
      enterButtonUrl={enterButtonUrl}
      header={header}
      rulesText={rulesText}
      isAuthenticated={isUserAuthenticated}
      rollsRemaining={rollsRemaining}
      rollsRemainingLoading={rollsRemainingLoading}
    />
  );
};

export default HomepageBanner;
